import React from "react";
import PropTypes from 'prop-types';

export default class ContactOption extends React.Component {

    static propTypes = {
        model: PropTypes.object,

        isSelected: PropTypes.bool,

        onClick: PropTypes.func
    }

    onClick = () => {
        if (this.props.onClick) this.props.onClick(this.props.model.id);
    }

    render() {
        const classes = Classes("row", "search-item", {
            'selected': this.props.isSelected,
        });

        const crmAccount = gd.session.crmAccounts.get(this.props.model.crmAccountId);

        return (
            <div className={classes} onClick={this.onClick}>
                <div className="cell">
                    <div className="ui5-ico-13 m-r-10 i5-crm-contact"/>
                    <div className="ui5-txt-default max-w-250">{this.props.model.name}</div>
                </div>
                <div className="cell align-r">
                    {crmAccount && <div className="ui5-txt-less-important max-w-200">{crmAccount.name}</div>}
                    {!crmAccount && <div className="ui5-txt-no-accent-default max-w-200">no account</div>}
                </div>
            </div>
        )
    }
}